import React from "react";
import Layout from "../components/Layout";
import { graphql } from "gatsby";
import PageHeader from "../components/PageHeader";
import Section from "../components/Section";
import SectionTitle from "../components/SectionTitle";
import Card from "../components/NewCard";
import Seo from "../components/Seo";

export default function News({ data, location }) {
  const news_md = data.news_md.nodes;

  let sortedPosts = [];
  let years = [];
  let i = 0;

  news_md.forEach((post) => {
    let year = post.frontmatter.date.substr(0, 4);

    if (!years.includes(year)) {
      years.push(year);
      sortedPosts[i] = [];
      i++;
    }

    let yearIndex = years.indexOf(year);

    sortedPosts[yearIndex].push(post);
  });

  return (
    <Layout>
      <Seo
        title="robo4you - News."
        description="Neuigkeiten und Aktuelles zu unseren Aktivitäten."
        url={location.pathname}
        section="news"
      />
      <PageHeader title="Neuigkeiten" />
      <Section noPadding pb>
        <div className="grid grid-cols-1 md:grid-cols-3 grid-rows-auto gap-6">
          {sortedPosts
            .flat()
            .slice(0, 3)
            .map((post) => {
              return (
                <Card
                  key={post.frontmatter.title}
                  loading="eager"
                  image={post.frontmatter.cover}
                  title={post.frontmatter.title}
                  content={post.frontmatter.summary}
                  link={"/posts" + post.fields.slug}
                  category={post.frontmatter.category}
                  date={post.frontmatter.date}
                  author={post.frontmatter.author}
                />
              );
            })}
        </div>
      </Section>
      {sortedPosts.map((posts, index) => {
        return (
          <Section background={!(index % 2)} key={index}>
            {index === 0 && (
              <SectionTitle
                title="Chronik"
                desc="Archiv der Vergangenheit. Artikel, gesammelt aus mehr als zehn Jahren Vereinsgeschichte."
              />
            )}
            <h1 className="mb-4 md:mb-6 font-bold text-2xl md:text-4xl">
              {years[index]}
            </h1>
            <div className="grid grid-cols-1 md:grid-cols-3 grid-rows-auto gap-6">
              {posts.map((post) => {
                return (
                  <Card
                    key={post.fields.slug}
                    loading={index === 0 ? "eager" : undefined}
                    image={post.frontmatter.cover}
                    title={post.frontmatter.title}
                    content={post.frontmatter.summary}
                    link={"/posts" + post.fields.slug}
                    category={post.frontmatter.category}
                    date={post.frontmatter.date}
                    author={post.frontmatter.author}
                  />
                );
              })}
            </div>
          </Section>
        );
      })}
    </Layout>
  );
}

export const pageQuery = graphql`
  query NewsQuery {
    news_md: allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "/posts/" } }
      sort: { frontmatter: { date: DESC } }
    ) {
      nodes {
        id
        fileAbsolutePath
        frontmatter {
          date
          title
          summary
          category
          author
          cover {
            childImageSharp {
              gatsbyImageData(
                aspectRatio: 1.7777777
                formats: [AUTO, WEBP]
                transformOptions: { cropFocus: NORTH }
                width: 418
              )
            }
          }
        }
        fields {
          slug
        }
      }
    }
  }
`;
